import { render, staticRenderFns } from "./PopUpInputTable.vue?vue&type=template&id=4ac4050e&scoped=true"
import script from "./PopUpInputTable.vue?vue&type=script&lang=js"
export * from "./PopUpInputTable.vue?vue&type=script&lang=js"
import style0 from "./PopUpInputTable.vue?vue&type=style&index=0&id=4ac4050e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4050e",
  null
  
)

export default component.exports